import { ActionType, ModalVariant } from '@/components/Modals/types';
import {
  ContentCollectionGroupType,
  ContentEntity,
  ContentQueryIntentEnum,
  EventSelectionInput,
  EventStatusEnum,
  EventUnion,
  GroupQueryIntentEnum,
  RecurringTypeEnum,
  ResourceTypeEnum,
} from '@/types/schema';

export enum Tabs {
  Content = 'CONTENT',
  Sessions = 'SESSIONS',
  Collections = 'COLLECTIONS',
}

export interface ContentsDialogProps {
  onClose: () => void;
  onAddItems: ({
    selectedContentIds,
    selectedCollectionIds,
    allowDuplication,
    eventSelections,
  }: {
    selectedContentIds: string[];
    selectedCollectionIds: string[];
    allowDuplication?: boolean;
    eventSelections: EventSelectionInput[];
  }) => void;
  dialogConfigs?: {
    contentTypes?: ResourceTypeEnum[];
    eventStatus?: EventStatusEnum[];
    tabConfig?: Tabs[];
    contentQueryIntent?: ContentQueryIntentEnum;
    groupQueryIntent?: GroupQueryIntentEnum;
    recurringCategories?: RecurringTypeEnum[];
  };
  strings?: {
    title?: string;
    description?: string;
    primaryButtonText?: string;
    secondaryButtonText?: string;
    searchPlaceholder?: string;
  };
  selectedIds: {
    selectedContentIds?: string[];
    selectedCollectionIds?: string[];
    eventSelections?: EventSelectionInput[];
  };
  dialogActions?: {
    isAlreadySelected?: boolean;
    isMultiAllowed?: boolean;
    loading?: boolean;
    shareable?: boolean;
    isAssingmentTypeChangeAllowed?: boolean;
    showDuration?: boolean;
  };
  TertiaryAction?: ActionType['TertiaryAction'];
  disabledIds?: string[];
  variant?: ModalVariant;
}

export type Items = ContentEntity | ContentCollectionGroupType | EventUnion;
